import React from "react"
import { FormikProps } from "formik"
import i18n from "@/i18n"
import RegularHourItem from "./regular_hour_item"
import { WEEKDAYS } from "./constants"

const STYLES = {
  section: "bg-white rounded-lg p-6",
  sectionHeader: "text-xl font-semibold mb-0 mt-0",
  headerRow: "flex justify-between items-start mb-6",
  scheduleList: "flex flex-col gap-3",
} as const

interface RegularHour {
  id?: string
  weekday: number
  closed: boolean
  startTime: string
  endTime: string
}

interface RegularHoursSectionProps {
  regularHours: RegularHour[]
  formik: FormikProps<any>
}

const RegularHoursSection: React.FC<RegularHoursSectionProps> = ({ regularHours, formik }) => {
  return (
    <div className={STYLES.section} data-testid="settings-venue-hours-regular-container">
      <div className={STYLES.headerRow}>
        <h2 className={STYLES.sectionHeader}>{i18n.t("app.settings.venues.opening_hours.regular_hours")}</h2>
      </div>

      <div className={STYLES.scheduleList}>
        {WEEKDAYS.map((day, index) => {
          const hour = regularHours[index]
          return (
            <RegularHourItem
              key={day.value}
              weekday={i18n.t(`app.days.${day.key}`)}
              dayIndex={index}
              closed={hour.closed}
              startTime={hour.startTime}
              endTime={hour.endTime}
              onClosedChange={(closed) => formik.setFieldValue(`regularHours.${index}.closed`, closed)}
              onStartTimeChange={(time) => formik.setFieldValue(`regularHours.${index}.startTime`, time)}
              onEndTimeChange={(time) => formik.setFieldValue(`regularHours.${index}.endTime`, time)}
            />
          )
        })}
      </div>
    </div>
  )
}

export default RegularHoursSection
